// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { MaintainApi } from '../../../services/maintain';
import { dotted } from '../../../../assets/imgs';

import './footer.scss';

export default function Footer() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const path = location?.pathname;
  const listLink = [
    { title: '運営会社', onclick: () => window.open('https://bushiroad-creative.com/') },
    { title: '利用規約', onclick: () => history.push('/terms'), route: '/terms' },
    {
      title: '特定商取引法に基づく表示',
      onclick: () => history.push('/commercial-transaction-law'),
      route: '/commercial-transaction-law',
    },
    {
      title: 'プライバシーポリシー',
      onclick: () => window.open('https://bushiroad-creative.com/pages/policy'),
    },
    { title: 'お問い合わせ', onclick: () => history.push('/contact'), route: '/contact' },
    {
      title: 'よくある質問',
      onclick: () => history.push('/frequently-question'),
      route: '/frequently-question',
    },
    // { title: 'システム導入について', onclick: () => window.open('/lp', '_blank') },
  ];

  useEffect(async () => {
    const res = await MaintainApi.getMaintainData();
    const { data } = res;
    if (data?.status && path !== 'maintain') {
      history.push('/maintain');
    }
  }, [path]);

  return (
    <>
      <div className="w-100" id="footer-wrapper">
        <div className="footer NotoSansJP400">
          <div className="footer-content">
            {listLink?.map((link, index) => {
              return (
                <div
                  key={index}
                  className={
                    path === link.route ? 'content-item content-item-active' : 'content-item'
                  }
                >
                  <div onClick={link.onclick}>{link.title}</div>
                  {index !== listLink.length - 1 && (
                    <div className="footer-svg">
                      <svg
                        id="special_3"
                        xmlns="http://www.w3.org/2000/svg"
                        width={2}
                        height={20}
                        viewBox="0 0 2 20"
                      >
                        <circle
                          id="Ellipse_53"
                          data-name="Ellipse 53"
                          cx={1}
                          cy={1}
                          r={1}
                          fill="#2adad1"
                        />
                        <circle
                          id="Ellipse_54"
                          data-name="Ellipse 54"
                          cx={1}
                          cy={1}
                          r={1}
                          transform="translate(0 6)"
                          fill="#2adad1"
                        />
                        <circle
                          id="Ellipse_55"
                          data-name="Ellipse 55"
                          cx={1}
                          cy={1}
                          r={1}
                          transform="translate(0 12)"
                          fill="#2adad1"
                        />
                        <circle
                          id="Ellipse_56"
                          data-name="Ellipse 56"
                          cx={1}
                          cy={1}
                          r={1}
                          transform="translate(0 18)"
                          fill="#2adad1"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="text-center">{t('copyRight')}</div>
          <div
            className="border-dots border-absolute"
            style={{
              backgroundImage: `url(${dotted})`,
              backgroundSize: '1200px',
              height: '10px',
            }}
          ></div>
        </div>
      </div>
    </>
  );
}
